import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../api';

import { makeStyles } from '@material-ui/core/styles';
import {
  Input,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  Select,
  MenuItem,
} from '@material-ui/core';

import { setCarInsurance, setValidCar } from '../../redux/carInsurance';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './style.scss';
import AddBrand from '../AddBrand';
import { useGetLastYears } from '../../hooks/useGetLastYears';

const builInitialValues = () => {
  let carInfo = {
    carYear: '',
    carGNC: '',
    carPriceGNC: '',
    carCity: '',
    carPostCode: '',
    carPreferencePay: '',
  };
  return carInfo;
};

const useStyles = makeStyles({
  hideStyle: {
    visibility: 'hidden',
  },
  showStyle: {
    visibility: 'visible',
  },
});

const validationSchema = Yup.object({
  carPriceGNC: Yup.number()
    //.required()
    .typeError('ingrese un valor numérico')
    .min(10000, 'valor mínimo $10000')
    .max(200000, 'valor máximo $200000'),
});

export default function AddPrice(props) {
  const { nextWasRequired } = props;
  const dispatch = useDispatch();

  const classes = useStyles();

  const [showResults, setShowResults] = useState(false);

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
    carBrand: carInsurance.userCarInsurance.carBrand,
    carModel: carInsurance.userCarInsurance.carModel,
    carYear: carInsurance.userCarInsurance.carYear,
  }));

  const initialValues = builInitialValues(userCarInsurance);

  const { values, errors, touched, setFieldValue, handleBlur } = useFormik({
    initialValues,

    validationSchema,
  });

  useEffect(() => {
    const validationErrors = Object.keys(errors).length > 0;
    const valuesRequired =
      values.carYear &&
      values.carGNC &&
      values.carPriceGNC &&
      values.carCity &&
      values.carPostCode &&
      values.carPreferencePay &&
      true;

    if (!validationErrors && valuesRequired) {
      dispatch(setValidCar({ isValid: true }));
    }
    if (validationErrors || !valuesRequired) {
      dispatch(setValidCar({ isValid: false }));
    }
  }, [values, errors]);

  const hasError = (input, inputValue) =>
    (touched[input] && errors[input]) || (nextWasRequired && inputValue === '');

  const error = 'campo obligatorio';

  function handleChange(e) {
    const key = e.target.name;
    let value = e.target.value;
    setFieldValue(key, value);
    dispatch(setCarInsurance({ [key]: value }));
  }

  function getIndexByLocality(localities, locality) {
    return localities.findIndex(function (idLocal) {
      return idLocal.locality === locality;
    });
  }

  function getFirstValideIndex(localities) {
    return localities.findIndex((e) => e.description != '');
  }

  function handleChangeCarCity(e) {
    const key = e.target.name;
    let value = e.target.value.locality;

    let indexNew = getIndexByLocality(locality, value);
    let indexFirstValidate = getFirstValideIndex(localityId);

    dispatch(
      setCarInsurance({
        suraLocalityId:
          localityId[indexNew].description != ''
            ? localityId[indexNew].description
            : localityId[indexFirstValidate].description,
      })
    );
    setFieldValue(key, value);
    dispatch(setCarInsurance({ [key]: value }));
  }

  function handleChangeCarYear(e) {
    const key = e.target.name;
    let value = e.target.value;
    setFieldValue(key, value);
    if (value === '0Km') {
      dispatch(setCarInsurance({ isNew: 'true' }));
      dispatch(setCarInsurance({ [key]: currentYear.toString() }));
    } else {
      dispatch(setCarInsurance({ isNew: 'false' }));
      dispatch(setCarInsurance({ [key]: value }));
    }
  }

  function handleChangeCarGNC(e) {
    const key = e.target.name;
    let value = e.target.value;
    if (value === 'true') {
      values.carPriceGNC = '';
      setShowResults(true);
    } else if (value === 'false') {
      setShowResults(false);
      values.carPriceGNC = '10000';
    }
    setFieldValue(key, value);
    dispatch(setCarInsurance({ [key]: value }));
  }

  function handleChangeCarPostCode(e) {
    const key = e.target.name;
    let value = e.target.value;
    setFieldValue(key, value);
    if (value >= 1000 && value < 1599) {
      value = '1001';
    }
    dispatch(setCarInsurance({ [key]: value }));
  }

  const { currentYear, recentYears } = useGetLastYears({ years: 20 })

  const [locality, setLocality] = useState([]);
  const [localityId, setLocalityId] = useState([]);

  useEffect(() => {
    if (
      values.carPostCode &&
      parseInt(values.carPostCode) >= 1000 &&
      parseInt(values.carPostCode) <= 9999
    ) {
      const getLocalities = async () => {
        try {
          const { data } = await api.get(
            // return differents localities for the same zipcode
            `/localidad/codPostal/${values.carPostCode}/ch/PDS`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setLocality(data.Locality);
          setLocalityId(data.insuranceCompanies[0].Localitys);
        } catch (e) {
          setLocality('NULL');
        }
      };
      getLocalities();
      
    }
  }, [values.carPostCode]);

  const { token } = useSelector(({ auth }) => ({
    token: auth.token,
  }));

  return (
    <>
      {/* {open && <Modal>{renderModal()}</Modal>} */}
      <div className='Form-Container-AddressForm'>
        <form className='col s12'>
          <div className='row'>
            <div className='select-custom'>
              <div className='input-field col s12 l6'>
                <Select
                  id='carYear'
                  labelId='carYear'
                  name='carYear'
                  value={values.carYear}
                  className={`validate inputField selectField ${
                    hasError('carYear', values.carYear) ? 'error' : ''
                  }`}
                  classes={{ root: 'menuSelect', icon: 'caret' }}
                  inputProps={{
                    classes: {
                      icon: 'caret',
                    },
                  }}
                  onChange={handleChangeCarYear}
                  onBlur={handleBlur}
                >
                  <MenuItem value={'0Km'}>{ currentYear } 0km</MenuItem>
                  { recentYears &&
                    recentYears.map((item, key) => {
                      return (
                        <MenuItem key={key} value={item.toString()}>
                          {item}
                        </MenuItem>
                      );
                  })}
                </Select>
                <span htmlFor='carYear'>Año</span>
                <p className='error-text error-select'>
                  {hasError('carYear', values.carYear) && error}
                </p>
              </div>
            </div>

            <AddBrand
              nextWasRequired={nextWasRequired}
              year={
                values.carYear === '0Km'
                  ? currentYear.toString()
                  : values.carYear
              }
            />

            <div className='select-field col s12 l6'>
              <div style={{ marginTop: 15 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <FormControl component='fieldset'>
                    <FormLabel component='legend'>GNC</FormLabel>
                    <RadioGroup
                      aria-label='carGNC'
                      name='carGNC'
                      value={values.carGNC}
                      onChange={handleChangeCarGNC}
                      className={`validate inputField selectField ${
                        hasError('carGNC', values.carGNC) ? 'error' : ''
                      }`}
                    >
                      <FormControlLabel
                        value='false'
                        control={<Radio />}
                        label='No'
                      />
                      <FormControlLabel
                        value='true'
                        control={<Radio />}
                        label='Si'
                      />
                    </RadioGroup>
                    <p className='error-text'>
                      {hasError('carGNC', values.carGNC) && error}
                    </p>
                  </FormControl>

                  {showResults ? (
                    <>
                      <FormControl component='fieldset'>
                        <FormLabel component='legend'>
                          ($) Valor equipo
                        </FormLabel>
                        <div className={classes.showStyle}>
                          <Input
                            id='carPriceGNC'
                            name='carPriceGNC'
                            value={values.carPriceGNC}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={hasError('carPriceGNC')}
                            classes={{ root: classes.input }}
                            // className={`validate inputField selectField ${
                            //   hasError('carPriceGNC', values.carPriceGNC)
                            //     ? 'error'
                            //     : ''
                            // }`}
                          />
                          <p className='error-text error-GNC'>
                            {hasError('carPriceGNC', values.carPriceGNC) &&
                              error}
                          </p>
                          <FormHelperText error={hasError('carPriceGNC')}>
                            {hasError('carPriceGNC') && errors.carPriceGNC}
                          </FormHelperText>
                        </div>
                      </FormControl>
                    </>
                  ) : (
                    <div className={classes.hideStyle}>
                      <InputLabel
                        shrink
                        focused={false}
                        htmlFor='carPriceGNC'
                        style={{ padding: 5, fontSize: 17 }}
                      >
                        Valor equipo
                      </InputLabel>
                      <Input
                        id='carPriceGNC'
                        name='carPriceGNC'
                        value={values.carPriceGNC}
                        onChange={handleChange}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='input-field col s12 l3 container-postcode'>
              <input
                value={values.carPostCode}
                id='carPostCode'
                name='carPostCode'
                type='text'
                className={`validate inputField ${
                  hasError('carPostCode', values.carPostCode) ? 'error' : ''
                }`}
                onChange={handleChangeCarPostCode}
                onBlur={handleBlur}
                maxLength='4'
              />
              <span htmlFor='carPostCode' className='title-postcode'>
                Código Postal
              </span>
              <p className='error-text'>
                {hasError('carPostCode', values.carPostCode) && error}
              </p>
            </div>

            <div className='input-field col s12 l3'>
              <Select
                id='carCity'
                labelId='carCity'
                name='carCity'
                value={values.carCity.locality}
                value2={values.carCity.locality}
                className={`validate inputField selectField ${
                  hasError('carCity', values.carCity.locality) ? 'error' : ''
                }`}
                classes={{ root: 'menuSelect', icon: 'caret' }}
                inputProps={{
                  classes: {
                    icon: 'caret',
                  },
                }}
                onChange={handleChangeCarCity}
                onBlur={handleBlur}
                disabled={ locality && locality?.length ? false : true }
              >
                {locality !== 'NULL' &&
                  locality.map((item, key) => {
                    return (
                      <MenuItem key={key} value={item}>
                        {item.locality}
                      </MenuItem>
                    );
                  })}
              </Select>
              <span htmlFor='carCity'>Localidad</span>
              <p className='error-text error-select'>
                {hasError('carCity', values.carCity) && error}
              </p>
            </div>

            <div className='select-field col s12 l6'>
              <div style={{ marginTop: 18 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <FormControl component='fieldset'>
                    <FormLabel component='legend'>
                      ¿Cuál es tu preferencia de pago?
                    </FormLabel>
                    <RadioGroup
                      aria-label='carPreferencePay'
                      name='carPreferencePay'
                      value={values.carPreferencePay}
                      onChange={handleChange}
                      className={`validate inputField selectField ${
                        hasError('carPreferencePay', values.carPreferencePay)
                          ? 'error'
                          : ''
                      }`}
                    >
                      <FormControlLabel
                        value='debitoCuenta'
                        control={<Radio />}
                        label='Débito automático en cuenta'
                      />
                      <FormControlLabel
                        value='debitoTarjetaCredito'
                        control={<Radio />}
                        label='Débito automático en Tajeta de Crédito'
                      />
                    </RadioGroup>
                    <p className='error-text'>
                      {hasError('carPreferencePay', values.carPreferencePay) &&
                        error}
                    </p>
                  </FormControl>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
